export interface Variable {
  value: string;
  label: string;
  // Data type when known ('number', 'date', 'datetime'…) — used by the format panel to suggest a format, never to restrict
  type?: string;
  // Set when the value already arrives formatted at render time : the matching format option is hidden in the picker
  preformatted?: 'currency' | 'date';
}

// @TODO : mettre à jour le tableau des variables disponibles avec les dernières variables de prod
const allVariables: Variable[] = [
  { value: '{var=contact.first_name}', label: 'templateBuilder.variables.contactFirstname' },
  { value: '{var=contact.last_name}', label: 'templateBuilder.variables.contactLastname' },
  { value: '{var=contact.email}', label: 'templateBuilder.variables.contactEmail' },
  { value: '{var=contact.gender}', label: 'templateBuilder.variables.contactGender' },
  { value: '{var=shop.url https=false}', label: 'templateBuilder.variables.siteUrlWithoutHttp' },
  { value: '{var=shop.privacy_policy_url}', label: 'templateBuilder.variables.privacyPolicyUrl' },
  { value: '{var=shop.data_manager_email}', label: 'templateBuilder.variables.dataManagerEmail' },
  { value: '{var=shop.name}', label: 'templateBuilder.variables.siteName' },
  { value: '{var=shop.url}', label: 'templateBuilder.variables.siteUrl' },
  { value: '{var=shop.logo_url}', label: 'templateBuilder.variables.logoUrl' },
  { value: '{var=shop.push_icon_url}', label: 'templateBuilder.variables.pushIconUrl' },
  { value: '{var=shop.address}', label: 'templateBuilder.variables.shopAddress' },
  { value: '{var=cart.id_cart}', label: 'templateBuilder.variables.cartId' },
  { value: '{var=cart.url}', label: 'templateBuilder.variables.cartUrl' },
  { value: '{var=cart.amount}', label: 'templateBuilder.variables.cartAmount', type: 'number' },
  { value: '{var=visitor.last_category_view}', label: 'templateBuilder.variables.lastCategoryView' },
  { value: '{var=visitor.last_product_view}', label: 'templateBuilder.variables.lastProductView' },
  { value: '{var=visitor.best_category_context}', label: 'templateBuilder.variables.bestCategoryContext' },
  { value: '{var=visitor.best_product_context}', label: 'templateBuilder.variables.bestProductContext' },
  { value: '{var=visitor.last_product_view_url}', label: 'templateBuilder.variables.lastProductViewUrl' },
  { value: '{var=shop.link_double_optin}', label: 'templateBuilder.variables.linkDoubleOptin' },
  { value: '{var=contact.seniority}', label: 'templateBuilder.variables.customerSeniority' },
  { value: '{var=contact.lastorder_time}', label: 'templateBuilder.variables.customerLastorderTime' },
  { value: '{var=voucher.code}', label: 'templateBuilder.variables.voucherNumber' },
  { value: '{var=voucher.description}', label: 'templateBuilder.variables.voucherDescription' },
  { value: '{var=voucher.amount}', label: 'templateBuilder.variables.voucherAmount', preformatted: 'currency' },
  { value: '{var=voucher.minimum_order}', label: 'templateBuilder.variables.voucherMinimumOrder', preformatted: 'currency' },
  { value: '{var=voucher.date_end}', label: 'templateBuilder.variables.voucherDateLimit', preformatted: 'date' },
  { value: '{var=voucher.nb_day_validate}', label: 'templateBuilder.variables.voucherNbDayExpire' },
  { value: '{var=template.subject}', label: 'templateBuilder.variables.mailSubject' },
  { value: '{var=template.view_in_browser_url}', label: 'templateBuilder.variables.viewInBrowserUrl' },
  { value: '{var=template.unsubscribe_url}', label: 'templateBuilder.variables.unsubscribeUrl' },
  { value: '{var=template.tracking_preferences_url}', label: 'templateBuilder.variables.trackingPreferencesUrl' },
  { value: '{var=order.id_order}', label: 'templateBuilder.variables.orderId' },
  { value: '{var=order.amount}', label: 'templateBuilder.variables.orderAmount', type: 'number' },
  { value: '{var=order.reference}', label: 'templateBuilder.variables.orderReference' },
  { value: '{var=order.status.name}', label: 'templateBuilder.variables.orderStatus' },
  { value: '{var=campaign_type}', label: 'templateBuilder.variables.campaignType' },
  { value: '{var=campaign_name}', label: 'templateBuilder.variables.campaignName' },
  { value: '{var=contact.id_customer_shop}', label: 'templateBuilder.variables.campaignUserId' },
  { value: '{var=campaign_send_key}', label: 'templateBuilder.variables.campaignSendKey' },
  { value: '{var=campaign_link}', label: 'templateBuilder.variables.campaignLink' },
  { value: '{var=product.id_product}', label: 'templateBuilder.variables.productId' },
  { value: '{var=product.id_combination}', label: 'templateBuilder.variables.productCombination' },
  { value: '{var=product.name}', label: 'templateBuilder.variables.productTitle' },
  { value: '{var=product.url}', label: 'templateBuilder.variables.productUrl' },
  { value: '{var=product.image_url resize=400x400 resizeType=fill-to-fit}', label: 'templateBuilder.variables.productImageUrl' },
  { value: '{var=product.description_short}', label: 'templateBuilder.variables.productDescription' },
  { value: '{var=product.manufacturer.id}', label: 'templateBuilder.variables.productManufacturerId' },
  { value: '{var=product.manufacturer.name}', label: 'templateBuilder.variables.productManufacturer' },
  { value: '{var=product.price}', label: 'templateBuilder.variables.productPrice', preformatted: 'currency' },
  { value: '{var=product.price_strike}', label: 'templateBuilder.variables.productPriceStrike', preformatted: 'currency' },
  { value: '{var=product.price_discount}', label: 'templateBuilder.variables.productPriceDiscount', preformatted: 'currency' },
  { value: '{var=product.price_display}', label: 'templateBuilder.variables.productPriceDisplay', preformatted: 'currency' },
  { value: '{var=product.price_amount}', label: 'templateBuilder.variables.productPriceAmount', type: 'number' },
  { value: '{var=product.price_strike_amount}', label: 'templateBuilder.variables.productPriceStrikeAmount', type: 'number' },
  { value: '{var=social.facebook_url}', label: 'templateBuilder.variables.socialFacebook' },
  { value: '{var=social.twitter_url}', label: 'templateBuilder.variables.socialTwitter' },
  { value: '{var=social.pinterest_url}', label: 'templateBuilder.variables.socialPinterest' },
  { value: '{var=social.tumblr_url}', label: 'templateBuilder.variables.socialTumblr' },
  { value: '{var=social.instagram_url}', label: 'templateBuilder.variables.socialInstagram' },
  { value: '{var=social.contact_url}', label: 'templateBuilder.variables.socialContact' },
  { value: '{var=social.youtube_url}', label: 'templateBuilder.variables.socialYoutube' },
  { value: '{var=social.whatsapp_url}', label: 'templateBuilder.variables.socialWhatsapp' },
  { value: '{var=social.snapchat_url}', label: 'templateBuilder.variables.socialSnapchat' },
  { value: '{var=social.tiktok_url}', label: 'templateBuilder.variables.socialSnapchat' },
  { value: '{var=social.phone}', label: 'templateBuilder.variables.socialPhone' },
  { value: '{var=social.email}', label: 'templateBuilder.variables.socialEmail' },
];

const aiVariables: Variable[] = [
  { value: '{var=contact.first_name}', label: 'templateBuilder.variables.contactFirstname' },
  { value: '{var=contact.last_name}', label: 'templateBuilder.variables.contactLastname' },
  { value: '{var=contact.email}', label: 'templateBuilder.variables.contactEmail' },
  { value: '{var=contact.gender}', label: 'templateBuilder.variables.contactGender' },
  { value: '{var=shop.name}', label: 'templateBuilder.variables.siteName' },
  { value: '{var=shop.url}', label: 'templateBuilder.variables.siteUrl' },
  { value: '{var=shop.address}', label: 'templateBuilder.variables.shopAddress' },
  { value: '{var=cart.amount}', label: 'templateBuilder.variables.cartAmount', type: 'number' },
  { value: '{var=visitor.last_category_view}', label: 'templateBuilder.variables.lastCategoryView' },
  { value: '{var=visitor.last_product_view}', label: 'templateBuilder.variables.lastProductView' },
  { value: '{var=visitor.best_category_context}', label: 'templateBuilder.variables.bestCategoryContext' },
  { value: '{var=visitor.best_product_context}', label: 'templateBuilder.variables.bestProductContext' },
  { value: '{var=visitor.last_product_view_url}', label: 'templateBuilder.variables.lastProductViewUrl' },
  { value: '{var=contact.seniority}', label: 'templateBuilder.variables.customerSeniority' },
  { value: '{var=contact.lastorder_time}', label: 'templateBuilder.variables.customerLastorderTime' },
  { value: '{var=voucher.code}', label: 'templateBuilder.variables.voucherNumber' },
  { value: '{var=voucher.description}', label: 'templateBuilder.variables.voucherDescription' },
  { value: '{var=voucher.amount}', label: 'templateBuilder.variables.voucherAmount', preformatted: 'currency' },
  { value: '{var=voucher.minimum_order}', label: 'templateBuilder.variables.voucherMinimumOrder', preformatted: 'currency' },
  { value: '{var=voucher.date_end}', label: 'templateBuilder.variables.voucherDateLimit', preformatted: 'date' },
  { value: '{var=voucher.nb_day_validate}', label: 'templateBuilder.variables.voucherNbDayExpire' },
  { value: '{var=order.amount}', label: 'templateBuilder.variables.orderAmount', type: 'number' },
  { value: '{var=order.reference}', label: 'templateBuilder.variables.orderReference' },
  { value: '{var=order.status.name}', label: 'templateBuilder.variables.orderStatus' },
];

// ---- Variable grouping for the picker modal ----

export interface EnrichedVariable {
  value: string;
  label: string;
  displayLabel?: string;
  isCustom?: boolean;
  isFromCollection?: boolean;
  isMetadata?: boolean;
  // Data type when known ('number', 'date', 'datetime'…) — used by the format panel to suggest a format, never to restrict
  type?: string;
  // Set when the value already arrives formatted at render time : the matching format option is hidden in the picker
  preformatted?: 'currency' | 'date';
}

export interface VariableGroup {
  key: string;
  label: string;
  icon: string;
  color: string;
  bg: string;
  items: EnrichedVariable[];
}

export const VARIABLE_GROUP_CONFIG: Record<string, { icon: string; color: string; bg: string }> = {
  contact:          { icon: 'fa-light fa-user',         color: '#7c3aed', bg: '#ede9fe' },
  shop:             { icon: 'fa-light fa-store',        color: '#d97706', bg: '#fef3c7' },
  cart:             { icon: 'fa-light fa-cart-shopping', color: '#2563eb', bg: '#dbeafe' },
  visitor:          { icon: 'fa-light fa-eye',          color: '#059669', bg: '#d1fae5' },
  voucher:          { icon: 'fa-light fa-ticket',       color: '#db2777', bg: '#fce7f3' },
  template:         { icon: 'fa-light fa-envelope',     color: '#4f46e5', bg: '#e0e7ff' },
  order:            { icon: 'fa-light fa-box',          color: '#ea580c', bg: '#ffedd5' },
  campaign:         { icon: 'fa-light fa-bullhorn',     color: '#ca8a04', bg: '#fef9c3' },
  product:          { icon: 'fa-light fa-tag',          color: '#0891b2', bg: '#cffafe' },
  social:           { icon: 'fa-light fa-share-nodes',  color: '#9333ea', bg: '#f3e8ff' },
  customProperties: { icon: 'fa-light fa-puzzle-piece', color: '#8b5cf6', bg: '#ede9fe' },
  metadata:         { icon: 'fa-light fa-database',     color: '#f59e0b', bg: '#fff7ed' },
  iteration:        { icon: 'fa-light fa-rotate',       color: '#06b6d4', bg: '#ecfeff' },
  other:            { icon: 'fa-light fa-circle',       color: '#6b7280', bg: '#f3f4f6' },
};

const GROUP_ORDER = [
  'contact', 'shop', 'cart', 'visitor', 'voucher', 'template',
  'order', 'campaign', 'product', 'social',
  'customProperties', 'metadata', 'iteration', 'other',
];

const PREFIX_ALIASES: Record<string, string> = {
  metaData: 'metadata',
};

function extractGroupKey(variable: EnrichedVariable): string {
  if (variable.isFromCollection) return 'iteration';
  if (variable.isMetadata) return 'metadata';
  if (variable.isCustom) return 'customProperties';

  const match = variable.value.match(/\{var=([a-zA-Z]+)[._\s}]/);
  if (!match) return 'other';
  const raw = match[1];
  const normalized = PREFIX_ALIASES[raw] || raw;
  return GROUP_ORDER.includes(normalized) ? normalized : 'other';
}

export function groupVariables(
  flatVars: EnrichedVariable[],
  t: (key: string) => string,
): VariableGroup[] {
  const buckets: Record<string, EnrichedVariable[]> = {};
  GROUP_ORDER.forEach((key) => { buckets[key] = []; });

  flatVars.forEach((variable) => {
    const key = extractGroupKey(variable);
    buckets[key].push(variable);
  });

  const hasIteration = buckets.iteration.length > 0;
  const orderedKeys = hasIteration
    ? ['iteration', ...GROUP_ORDER.filter((k) => k !== 'iteration')]
    : GROUP_ORDER;

  return orderedKeys
    .filter((key) => buckets[key].length > 0)
    .map((key) => {
      const config = VARIABLE_GROUP_CONFIG[key];
      return {
        key,
        label: t(`templateBuilder.variableGroups.${key}`),
        icon: config.icon,
        color: config.color,
        bg: config.bg,
        items: buckets[key],
      };
    });
}

export default {
  allVariables,
  aiVariables,
};
